//import { BotonPago } from "../../../stripe/src-react/src/BotonPago";
import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CifradoAES, CifradoRSA } from "../../components/FuncionesCifrado";
import { BASE_URL } from "../../config/api";
import SubirArchivosIndex from './SubirArchivosIndex';
const FormularioEnvioArchivos = () => {
  
  const [pkey, setPkey] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showStart, setShowStart] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showEnd, setShowEnd] = useState(false);
  const [diasGuardar, setDiasGuardar] = useState(3);
  const [precio, setPrecio] = useState(0);
  const [modalType, setModalType] = useState('');
  const [bytesTotales, setBytesTotales] = useState(0);
  const [error, setError] = useState(null);
  const [datosCorreo, setDatosCorreo] = useState({
    correoDestinatario: '',
    correoRemitente: '',
    asunto: '',
    mensaje: ''
  });
  const [datosCarga, setDatosCarga] = useState('');
  const [totalArchivos, setArchivo] = useState(0);
  const [startUpload, setStartUpload] = useState(false);
  const [datosValidacion, setDatosValidacion] = useState({
    url: '',
    size_bytes: '',
    folder_name: ''
  });
  const [copied, setCopied] = useState(false);
  const [btnEspera, setbtnEspera] = useState(false);

  // Constants
  const tokenSeguridad = 'xjC237RGCVCjFC6T8o25BScT2E3H9iPACvoPwn3RHB8ZHsZzmsnqJrydG4MrZrWLFXyKbU244vJYjMTTGSTB4cJDubWr8S7azn4fAJfRA6M3GQZDRi3LZbUXLqTV5DHi';
  const overlayRef = useRef(null);
  const aesEncryption = new CifradoAES();
  const rsaEncryption = new CifradoRSA();

  /* useEffect(() => {
    if (showModal && modalType === 'addFolder') {
        setTimeout(() => {
            newFolderInput.current?.focus();
        }, 0);
    }
  }, [showModal, modalType]); */

  useEffect(() => {
    if (pkey === '') {
      fetchPublicKey();
    }
  }, [pkey]);

  // fetching the key
  const fetchPublicKey = async () => {
    try {
        const formData = new FormData();
        const response = await fetch(`${BASE_URL}/cratos/ModuloSesion/PHP/Implementaciones/pedirLlavePublica.php`, {
            method: 'POST',
            body: formData,
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const publicKey = await response.text();

        setPkey(publicKey);
        
    } catch (error) {
        console.error('Error fetching public key:', error);
        alert("Error Cifrado Asimetrico: " + error.message);
    }
  }

  // Utility functions
  const formatBytes = useCallback((bytes, decimals = 2) => {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }, []);

  const validateUploads = async (failed, datos, bytes) => {
    if(failed > 0){
      setError("Fallo la subida de algunos archivos, por favor elige que quieres hacer.");
      return;
    }

    const  formData = new FormData();
    formData.append("ubicacion", datos.ubicacion);
    formData.append("id_carpeta", datos.id_carpeta);
    formData.append("bytesTotales", bytes);  
    formData.append("t_seg", tokenSeguridad);

    // Cifrando Envío
    for (let dato of formData.entries()) {
      console.log(dato);
      formData.set(dato[0], aesEncryption.cifrar(dato[1]).datos);
    }
    
    let llaveCifrada = await rsaEncryption.cifrar(aesEncryption.llave, pkey);
    formData.append("ivCifradoSimetrico", aesEncryption.iv);
    formData.append("keyCifradoSimetrico", llaveCifrada);

    fetch("cratos/ModuloArchivos/PHP/Implementaciones/crearZip.php", {
      method: 'POST',
      body: formData,
    })
    .then(response => response.json())
    .then(response => {
      console.log("validateUploads",response);
      //return; 
      try {
        const data = response;
        if (data.resultado == 'ok' && data.msj == 'procesarDespues') {
          setStartUpload(false);
          setbtnEspera(false);
          setBytesTotales(0);
          setDatosValidacion(prev => ({ ...prev, url: '',  size_bytes: '', folder_name: ''}));
          setShowForm(false);
          setShowEnd(true);
          
        } else if (data.resultado == 'ok' && data.msj == 'completado') {
          setStartUpload(false);
          setbtnEspera(false);
          setBytesTotales(0);
          setDatosValidacion(prev => ({ ...prev, url: data.url,  size_bytes: data.size_bytes, folder_name: data.folder_name}));
          setShowForm(false);
          setShowEnd(true);
        } else {
          setError(data.msj);
          setbtnEspera(false);
          console.error("ErrorValidateUploads:", data.msj);
        }
      } catch (error) {
        console.error("ErrorValidateUploads: reponse " + error);
        setError("Ocurrio un error inesperado, intentalo de nuevo mas tarde");
        setbtnEspera(false);
      }
    })
    .catch(error => {
      console.error('ErrorValidateUploadsFetch:', error);
      setError("Ocurrio un error inesperado, intentalo de nuevo mas tarde");
      setbtnEspera(false);      
    });
    overlayRef.current.setAttribute('style', "");
  }
  
  const actualizarPrecio = () => {
    if (this.totalPaga == 0) {
      this.setState({ precio: 0 })
      return;
    }
    let formData = new FormData();
    formData.append("tiempo", this.state.diasGuardar);
    formData.append("espacio", this.totalPaga);
    fetch("cratos/ModuloArchivos/PHP/Implementaciones/obtenerPrecio.php", {
      method: 'post',
      body: formData,
    })
      .then(response => response.text())
      .then(text => {
        if (parseInt(text, 10) > 0 || parseInt(text, 10) == 0) {
          this.precioActual = text;
          this.setState({ precio: '$' + text })
        } else {
          this.setState({ precio: 'No pudimos actualizar el precio :(' })
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  const archivoAgregado = (total, bytes) => {
    setArchivo(total);
    setBytesTotales(bytes);
  };

  const generarBotonPago = async () => {
    if (datosCorreo.correoDestinatario == "") {
      setError("Favor de introducir la direccion del destinatario");
      return;
    }
    if (datosCorreo.correoRemitente == "") {
      setError("Favor de introducir la direccion del remitente");
      return;
    }
    if (datosCorreo.asunto == "") {
      setError("Favor de introducir el asunto del correo");
      return;
    }
    if (totalArchivos < 1) {
      setError("Favor de seleccionar el archivo que desea enviar");
      return;
    }
    setError(null);
    setbtnEspera(true);
    //setStatus('Preparando...');
    //setMostrarProgreso(true);
    //overlayRef.current.setAttribute('style', "width: 100%;height: 100%; z-index: 10000;pointer-events: none;");
    /* if (this.state.precio != 0) {//con pago
      //--------------------------------------------------------------------------
      //----------------------------Subir Archivo Inicial Antes Del Pago----------
      //--------------------------------------------------------------------------
      let dt = new Date();
      let dtS = dt.getFullYear() + "-" + ("0" + (dt.getMonth() + 1)).slice(-2) + "-" + ("0" + dt.getDate()).slice(-2);// + " " + ("0" + dt.getHours()).slice(-2) + ":" + ("0" + dt.getMinutes()).slice(-2)+ ":" + ("0" + dt.getSeconds()).slice(-2);
      let hora = ("0" + dt.getHours()).slice(-2) + "-" + ("0" + dt.getMinutes()).slice(-2) + "-" + ("0" + dt.getSeconds()).slice(-2);
      let nombreCarpetaServidor = "NuestroNombre" + Math.floor(Math.random() * 10000000).toString() + "-" + dtS + "-" + hora;
      let cifradorAES = new CifradoAES();
      let cifradorRSA = new CifradoRSA();
      let formData = new FormData();
      formData.append("carpeta", nombreCarpetaServidor);
      formData.append("correoRemitente", this.state.correoRemitente);
      formData.append("correoDestinatario", this.state.correoDestinatario);
      formData.append("tituloCorreo", this.state.tituloCorreo);
      formData.append("mensajeCorreo", this.state.mensajeCorreo);
      formData.append("bytes", this.state.bytesTotales);
      //Campos Seguridad
      formData.append("t_seg", this.tokenSeguridad);
      if (sessionStorage.getItem("id_usuario") != null) {
        formData.append("token_usuario_seguridad", sessionStorage.getItem("token_nk546813"));
        formData.append("id_usuario", sessionStorage.getItem("id_usuario"));
        formData.append("tipo_usuario", sessionStorage.getItem("tipo_usuario"));
      }
      //----------------
      //Cifrando Envío
      for (let dato of formData.entries()) {
        formData.set(dato[0], cifradorAES.cifrar(dato[1]).datos)
      }
      let llaveCifrada = await cifradorRSA.cifrar(cifradorAES.llave, pkey);
      formData.append("ivCifradoSimetrico", cifradorAES.iv);
      formData.append("keyCifradoSimetrico", llaveCifrada);
      await fetch("cratos/ModuloArchivos/PHP/Implementaciones/crearCarpeta.php", {
        method: 'post',
        body: formData,
      })
      .then(response => response.text())
      .then(text => {
        try {
          if (text !== "ERROR") {
            let datos = JSON.parse(text);
            nombreCarpetaServidor = datos[0] + "_" + datos[1];
            this.setState({ nombreCarpetaServidor: nombreCarpetaServidor, datosCarga: text });
            setTimeout(() => { this.enviarArchivo(0); }, 1000);
          } else {
            alert("ErrorGenerarBotonPago:Ocurrió un error inesperado, por favor intente más tarde.");
          }
        } catch (error) {
          console.log('ErrorGenerarBotonPagotry:', error);
        }
      })
      .catch(error => {
        console.error('ErrorGenerarBotonPago:', error);
      });
      //--------------------------------------------------------------------------
      //----------------------------Realizar Pago En Segundo Plan------o----------
      //--------------------------------------------------------------------------
      this.id_pago = uuidv4();
      setTimeout(() => {
        this.modalPago.show(); */
        /*
        let json_id_archivo_subida = JSON.parse(id_archivo_subida);
        let formData = new FormData();
        formData.append("precio", this.state.precio);
        formData.append("folderName", folderName);
        formData.append("id", json_id_archivo_subida[0] + "&" + json_id_archivo_subida[1] + "&" + json_id_archivo_subida[2] + "&" + this.state.diasGuardar);

        fetch("cratos/ModuloPagos/PHP/integrarMP.php", {
          method: 'post',
          body: formData
        })
          .then(response => response.text())
          .then(text => {
            let link = JSON.parse(text);
            document.getElementById("botonMercadoPago").href = link.init_point;
            setTimeout(() => { document.getElementById("cerrarModalProcesandoSubida").click(); }, 1000);
            setTimeout(() => { document.getElementById("abrirModalAvisoPaga").click(); }, 1000);
          })
          .catch(error => {
            console.error('Error:', error);
          });*/
      //}, 1000);
    //} else {//sin pago
    try {
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      let nombreCarpetaServidor = `Neurobox_${timestamp}_${uuidv4()}`;
      const formData = new FormData();
      formData.append("carpeta", nombreCarpetaServidor);
      formData.append("correoRemitente", datosCorreo.correoRemitente);
      formData.append("correoDestinatario", datosCorreo.correoDestinatario);
      formData.append("tituloCorreo", datosCorreo.asunto);
      formData.append("mensajeCorreo", datosCorreo.mensaje);
      formData.append("bytes", bytesTotales);
      formData.append("t_seg", tokenSeguridad);
      
      if (sessionStorage.getItem("id_usuario") != null) {
        formData.append("token_usuario_seguridad", sessionStorage.getItem("token_nk546813"));
        formData.append("id_usuario", sessionStorage.getItem("id_usuario"));
        formData.append("tipo_usuario", sessionStorage.getItem("tipo_usuario"));
      }
      // Cifrando Envío
      for (let dato of formData.entries()) {
        formData.set(dato[0], aesEncryption.cifrar(dato[1]).datos);
      }
      
      let llaveCifrada = await rsaEncryption.cifrar(aesEncryption.llave, pkey);
      formData.append("ivCifradoSimetrico", aesEncryption.iv);
      formData.append("keyCifradoSimetrico", llaveCifrada); 

      const response = await fetch(`${BASE_URL}/cratos/ModuloArchivos/PHP/Implementaciones/crearCarpeta.php`, {
          method: 'POST',
          body: formData,
      });
      
      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const res = await response.json();
      try {
        if (res.success === true) {
          console.log('crearCarpeta', res.data);
          setDatosCarga(res.data);
          setTimeout(() => { setStartUpload(true); }, 100);
        }else{
          setError("Ocurrió un error inesperado, por favor intente más tarde.");
        }
      } catch (error) {
        console.error('Error creando carpeta:', error);
      }
        
    } catch (error) {
        console.error('Error creando carpeta:', error);
        //alert("Error Cifrado Asimetrico: " + error.message);
    }
    //}
  }
  /**
   * Render
   * 
   */
  return(<>
    {/* menu-navbar */}
    <nav className="navbar navbar-expand-lg sticky-top bg-light border border-bottom mb-2">
      <div className="container-fluid">
        
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav col-lg-6 justify-content-lg-center">
            <li key={'aboutus'} className="nav-item">
              <a className="nav-link" aria-current="page" href="#">Nosotros</a>
            </li>
            <li key={'solutions'} className="nav-item">
              <a className="nav-link" href="#">Soluciones</a>
            </li>
            <li key={'pricing'} className="nav-item">
              <a className="nav-link" href="#">Planes</a>
            </li>
          </ul>
          
        </div>
        <a className="navbar-brand fs-3" href="#">
          <img src="img/logo_blanco.svg" width={50} height={50}/>
        </a>
        <div className="float-end">
          <button className="btn btn-mas text-nowrap text-truncate me-2" id="btnPaquetesHeader" onClick={(e) => {
          e.preventDefault();
          //this.abrirModal();
          }}>
            <i className="bi bi-gem text-primary"></i>  Comprar espacio
          </button>
          <button className="btn btn-dark" type="button"><i className="bi bi-person-fill" style={{color:"#F28A00"}}></i></button>
        </div>
      </div>
    </nav>  
    <div ref={overlayRef} id="overlay">
    {showStart && (<>
      <div className="row">      
        <div className="col-1"></div>
        <div className="col-md-5 col-xs-12 mb-3">
            <div className="mb-3"><h1>NeuroBox</h1></div>
            <h2 className="mb-2" style={{color:"#F28A00"}}>Envía hasta 1 GB<br/>¡Gratis!</h2>
            <h3 className="mb-3">La mejor solución<br/>Fácil. Rápido. Seguro.</h3>
            <div className="btn-group" role="group">
              <button className="btn btn-mas text-nowrap text-truncate me-2" id="btnPaquetesHeader" onClick={(e) => {
              e.preventDefault();
              //this.abrirModal();
              }}>
                <i className="bi bi-gem text-primary"></i>  Comprar espacio
              </button>
            </div>
        </div>
        <div className="col-md-5 col-xs-12 mb-3">
          <div className="card h-100 border border-0">
            <div className="card-body p-1">
              <img src="img/neurospace-anim.gif" className="img-fluid mt-4" id="gif"></img>
            </div>
          </div>
        </div>
        <div className="col-1"></div>
        
          <div className='col-12 text-center mb-3'>
            <button type="button" className="btn btn-lg btn-dark" id='enviarGratis' onClick={()=>{setShowForm(true);}}>¡Enviar Gratis! <i className="bi bi-send"></i></button>
          </div>
      </div>
    </>)}
    {showForm && (<>
    <div className="row">
      <div className='col-md-6 col-xs-12' style={{height: '90vh', overflowY: 'auto'}}>
        <SubirArchivosIndex 
        tokenSeguridad={tokenSeguridad} 
        publicKeyRSA={pkey} 
        datosCarga={datosCarga} 
        startUpload={startUpload} 
        archivoAgregado={archivoAgregado} 
        validateUploads={validateUploads}/> 
      </div>
      <div className='col-md-6 col-xs-12'>
        <div className="row">
          <div className="col-12 mb-2">
            <div className="form-floating">
              <input type="email" className="form-control border border-1 border-dark" id="correoDestinatario" placeholder="example@example.com" 
              onChange={(e)=>{ e.preventDefault(); let s = e.currentTarget.value; setDatosCorreo(prev => ({ ...prev, correoDestinatario: s}));}} 
              value={datosCorreo.correoDestinatario} />
              <label>Enviar a</label>
            </div>
          </div>
          <div className="col-12 mb-2">
            <div className="form-floating">
              <input type="email" className="form-control border border-1 border-dark" id="correoRemitente" placeholder="example@example.com" 
              onChange={(e)=>{ e.preventDefault(); let s = e.currentTarget.value; setDatosCorreo(prev => ({ ...prev, correoRemitente: s}));}} 
              value={datosCorreo.correoRemitente} />
              <label>Tu correo</label>
            </div>
          </div>       
          <div className="col-12 mb-2" style={{ minHeight: "120px" }}>
            <div className="form-floating">
              <input type="text" className="form-control border border-1 border-dark" id="tituloCorreo" placeholder="Hola" 
              onChange={(e)=>{ e.preventDefault(); let s = e.currentTarget.value; setDatosCorreo(prev => ({ ...prev, asunto: s}));}} 
              value={datosCorreo.asunto} />
              <label>Asunto o Título</label>
            </div>
            <div className="form-floating">
              <textarea className="form-control border border-1 border-dark overflow-y" 
                id="mensajeCorreo" placeholder="Mensaje" 
                style={{ minHeight: "100px", maxHeight: "120px" }} 
                onChange={(e)=>{ e.preventDefault(); let s = e.currentTarget.value;  setDatosCorreo(prev => ({ ...prev, mensaje: s}));}}>
              </textarea>
              <label>Mensaje</label>
            </div>
          </div>
          <div className="col-12 mb-2">
            <div className="d-grid gap-2 col-6 mx-auto">
              {!btnEspera && (
                <button type="button" className="btn btn-dark btnEnviar" id="btnEnviar" onClick={() => { generarBotonPago(0); }}>
                  Transferir
                </button>
              )}
              {btnEspera && (
                <button type="button" className="btn btn-dark">
                  <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                </button>
              )}
            </div>            
          </div>
          {error && (
            <div className="alert alert-warning alert-dismissible fade show" role="alert">
              {error}
              <button
                type="button"
                className="btn-close"
                onClick={() => setError(null)}
                aria-label="Close"
              ></button>
            </div>
          )}
        </div>
      </div>
    </div>
    </>)}
    {showEnd && (<>
      {datosValidacion.url !== '' && (
        <div className="row">
          <div className="card h-100 border border-0">
            <div className="card-body">
              <div className="row align-items-center justify-content-center">
                <div className="col-6 mb-3">
                  <p className="text-center">
                    Destinatario {datosCorreo.correoDestinatario}
                  </p>
                </div>
                <div className="col-6 mb-3">
                  <p className="text-center">
                    Remitente {datosCorreo.correoRemitente}
                  </p>
                </div>
                <div className="col-6 mb-3">
                  <p className="text-center">
                    Archivo {datosValidacion.folder_name}
                  </p>
                </div>
                <div className="col-6 mb-3">
                  <p className="text-center">
                    Días disponible {diasGuardar}
                  </p>
                </div>
                <div className="col-6 mb-3">
                  <p className="text-center">
                    Tamaño archivo {formatBytes(datosValidacion.size_bytes)}
                  </p>
                </div>
                <div className="col-6 mb-3">
                  <div className="d-grid gap-2 d-md-flex justify-content-center">
                    <CopyToClipboard text={datosValidacion.url}
                      onCopy={() => setCopied(true)}>
                      <button type="button" className="btn btn-primary">
                        <i className="bi bi-clipboard"></i> Copiar link
                      </button>
                    </CopyToClipboard>
                      <a className="btn btn-primary" href={datosValidacion.url} role="button">
                        <i className="bi bi-download"></i>  Descargar
                      </a>
                  </div>
                  {copied ? <div className="alert alert-primary mt-3" role="alert">Copiado al porta papeles!</div> : null}
                </div>
                <div className="col-6">
                  <button type="button" className="btn btn-outline-success w-100" onClick={() => {
                    location.reload();
                  }}>
                    Finalizar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {datosValidacion.url === '' && (
        <div className="row">
          <div className="col-md-12 col-xs-12 mb-3 text-center">
            <p><span className="h4">Debido al tamaño total de los archivos la descarga tardara un poco en estar disponible.</span></p>
            <div className="d-grid gap-2 col-6 mx-auto">
              <button type="button" className="btn btn-lg btn-outline-success w-100" onClick={() => { window.location = "https://neurokratos.space/transferencia-archivos/EnvioArchivos.html"; }}>
                Finalizar
              </button>
            </div>
          </div>
        </div>
      )}
    </>)}

  </div>
</>)};
export default FormularioEnvioArchivos;